import { BUY_URL } from "@/data/products";
import { ArrowUpRight } from "lucide-react";

const links = [
  { label: "Brake Pads", href: "#pads" },
  { label: "Rotors", href: "#rotors" },
  { label: "Ethos", href: "#ethos" },
];

export const Navbar = () => {
  return (
    <header
      data-testid="main-nav"
      className="fixed top-0 left-0 right-0 z-50 bg-black/70 backdrop-blur-xl border-b border-white/10"
    >
      <nav className="mx-auto max-w-[1600px] px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-baseline gap-2 group">
          <span className="font-display text-2xl sm:text-3xl tracking-tight text-white leading-none">
            EBC
          </span>
          <span className="hidden sm:inline font-mono text-[10px] uppercase tracking-[0.3em] text-ebc-red group-hover:text-white transition-colors duration-300">
            Brakes
          </span>
        </a>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-white transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href={BUY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-buy-now"
          className="group inline-flex items-center gap-2 bg-ebc-red hover:bg-ebc-redhover text-white font-mono text-xs uppercase tracking-[0.15em] px-4 sm:px-6 py-2.5 sm:py-3 transition-colors duration-300"
        >
          Buy Now
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </nav>
    </header>
  );
};
